import axios from 'axios'
import { Auth } from 'aws-amplify'
import jwt from 'jsonwebtoken'

let baseUrl = 'https://api.wwest.io'

if (process.env.NODE_ENV === 'development') {
  baseUrl = 'http://localhost:5000/dev'
}

const token = async () => {
  const {
    idToken: { jwtToken },
  } = await Auth.currentSession()
  return jwtToken
}

const allIssues = async () =>
  axios
    .get(`${baseUrl}/issue/all`, {
      headers: {
        Authorization: await token(),
      },
    })
    .then(response => response.data)

const issueById = async issueId =>
  axios
    .get(`${baseUrl}/issue/${issueId}`, {
      headers: {
        Authorization: await token(),
      },
    })
    .then(response => response.data)

const currentStandings = async (page = 'app') =>
  axios
    .get(`${baseUrl}/currentStandings?page=${page}`, {
      headers: {
        Authorization: await token(),
      },
    })
    .then(response => response.data)

const updateStandings = async (standings, page) => {
  axios
    .post(
      `${baseUrl}/currentStandings`,
      {
        ranked: standings.ranked,
        unranked: standings.unranked,
        page,
      },
      {
        headers: {
          Authorization: await token(),
        },
      },
    )
    .then(response => response.data)
}

const ranking = async () =>
  axios
    .get(`${baseUrl}/ranking`, {
      headers: {
        Authorization: await token(),
      },
    })
    .then(response => response.data)

const isAdmin = async () => {
  const jsonToken = await token()
  const decoded = jwt.decode(jsonToken)
  const groups = decoded['cognito:groups']
  return groups.includes('admins')
}

const addIssue = async issueId =>
  axios
    .put(
      `${baseUrl}/issue/${issueId}`,
      {},
      {
        headers: {
          Authorization: await token(),
        },
      },
    )
    .then(response => response.data)

const removeIssue = async issueId =>
  axios
    .delete(`${baseUrl}/issue/${issueId}`, {
      headers: {
        Authorization: await token(),
      },
    })
    .then(response => response.data)

export { allIssues, issueById, currentStandings, updateStandings, isAdmin, ranking, addIssue, removeIssue }
